import { commonViewTexts } from '../../common';

export const trainingMessagesShared = {
  modelIsAvailable: `この${commonViewTexts.model}は図面カウントページで利用可能です。`,
  annotationCompleted: [
    'すべての画像のアノテーションが完了しました！',
    '学習を開始して推論モデルを作成しましょう。'
  ],
  annotationIncomplete: [
    'この推論モデルはアノテーションが完了していません。',
    '学習へ進むためには、すべてのデータのアノテーションを行ってください。'
  ],
  noLabelRegistered: [
    'この推論モデルはラベルが登録されていません。',
    '学習データのアノテーションへ進むためには、ラベルの登録を行ってください。'
  ],
  trainingError: '学習中にエラーが発生しました。再度学習を実行してください。',
  trainingRunning: [
    '現在学習中です。 ',
    '学習が完了すると登録者にメールで通知が送られますので、しばらくお待ち下さい。'
  ]
} as const;
